import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, ArrowRight, Sparkle, Plus } from "@phosphor-icons/react";

/** Cart preview rendered above the bottom nav when the Cart tab is long-pressed.
 * Pure presentational: data + handlers come from MobileBottomNav. */
export default function CartPeek({
  cart,
  cartCount,
  cartTotal,
  crossSells,
  format,
  onClose,
  onAddCrossSell,
  onTap,
}) {
  const peekItems = cart.slice(0, 3);
  const remaining = Math.max(0, cart.length - peekItems.length);

  return (
    <div className="md-bnav-peek" role="dialog" aria-label="Cart preview" data-testid="bnav-cart-peek">
      <div className="md-bnav-peek-head">
        <div className="md-bnav-peek-title">
          <ShoppingBag size={16} weight="duotone" /> Cart preview
          <span className="md-bnav-peek-count">{cartCount}</span>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="md-bnav-peek-close"
          aria-label="Close cart preview"
          data-testid="bnav-cart-peek-close"
        >×</button>
      </div>

      <ul className="md-bnav-peek-list">
        {peekItems.map((c) => (
          <li key={c.id} className="md-bnav-peek-item" data-testid={`bnav-peek-item-${c.id}`}>
            <div className="md-bnav-peek-thumb">
              {c.image_url ? <img src={c.image_url} alt={c.name} /> : <ShoppingBag size={18} weight="duotone" />}
            </div>
            <div className="md-bnav-peek-meta">
              <div className="md-bnav-peek-name">{c.name}</div>
              <div className="md-bnav-peek-sub">{c.qty} × {format(c.price)}</div>
            </div>
            <div className="md-bnav-peek-price">{format(c.price * c.qty)}</div>
          </li>
        ))}
      </ul>

      {remaining > 0 && (
        <div className="md-bnav-peek-more">+ {remaining} more {remaining === 1 ? "item" : "items"}</div>
      )}

      {crossSells.length > 0 && (
        <div className="md-bnav-peek-cross" data-testid="bnav-peek-crosssell">
          <div className="md-bnav-peek-cross-head">
            <Sparkle size={12} weight="fill" /> Pair it with
          </div>
          <ul className="md-bnav-peek-cross-list">
            {crossSells.map((p) => (
              <li key={p.id} className="md-bnav-peek-cross-item" data-testid={`bnav-peek-crosssell-${p.id}`}>
                <div className="md-bnav-peek-thumb">
                  {p.image_url ? <img src={p.image_url} alt={p.name} /> : <ShoppingBag size={16} weight="duotone" />}
                </div>
                <div className="md-bnav-peek-cross-meta">
                  <div className="md-bnav-peek-name">{p.name}</div>
                  <div className="md-bnav-peek-sub">{format(p.price)}</div>
                </div>
                <button
                  type="button"
                  onClick={onAddCrossSell(p)}
                  className="md-bnav-peek-cross-add"
                  aria-label={`Add ${p.name} to cart`}
                  data-testid={`bnav-peek-crosssell-add-${p.id}`}
                >
                  <Plus size={12} weight="bold" /> Add
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="md-bnav-peek-foot">
        <div className="md-bnav-peek-total">
          <span>Total</span>
          <strong>{format(cartTotal)}</strong>
        </div>
        <Link
          to="/cart"
          onClick={() => { onTap?.(); onClose(); }}
          className="md-bnav-peek-cta"
          data-testid="bnav-cart-peek-view"
        >
          View cart <ArrowRight size={13} weight="bold" />
        </Link>
      </div>
    </div>
  );
}
